import { createColumnHelper } from '@tanstack/react-table';
import { PortfolioPropertyGroupRateGroupCount } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { Stack, Table, TableHeader, TableProvider, Typography, useTableState } from '@optimus-web/core';
import { PolicyData } from '../types';
import { RemovePropertyButton } from './RemovePropertyButton';

const columnHelper = createColumnHelper<PortfolioPropertyGroupRateGroupCount>();

const columns = [
    columnHelper.accessor('name', {
        header: () => lt('Name'),
        cell: (props) => (
            <Stack vertical>
                <Typography textStyle="bodyMediumStrong" as="div">
                    {props.getValue()}
                </Typography>
                <Typography textStyle="bodyMedium" variant="tertiary" as="div">
                    {lt('PropertiesNumber', { count: props.row.original.propertyCount })}
                </Typography>
            </Stack>
        ),
    }),
    columnHelper.accessor('rateGroupCount', {
        header: () => lt('RateGroupPlural'),
        cell: (props) => props.getValue(),
    }),
    columnHelper.display({
        id: 'actions',
        meta: { align: 'end' },
        cell: (props) => <RemovePropertyButton propertyGroupId={props.row.original.id} />,
    }),
];

interface PropertiesGroupSectionProps {
    data: PolicyData;
}

export const PropertyGroupsSection = ({ data: { propertyGroupRateGroupCounts } }: PropertiesGroupSectionProps) => {
    const [tableState, setTableState] = useTableState<PortfolioPropertyGroupRateGroupCount>();

    const propertyGroupRows =
        propertyGroupRateGroupCounts?.filter(({ name }) => name.includes(tableState.globalFilters.search ?? '')) ?? [];
    const propertyGroupCount = propertyGroupRows.length;

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <TableHeader title={lt('PropertyGroupsTableHeader')} subTitle={propertyGroupCount} />
            <Table data={propertyGroupRows} amountOfRows={propertyGroupCount} uniqueRowId="id" />
        </TableProvider>
    );
};
